import type {Editor} from 'grapesjs';
import {useEffect} from 'react';
import {EMAIL_MAKER_PROPS} from '@EmailMakerReact/email-maker-react.constants';
import {getMainWrapper} from '@EmailMakerReact/lib/email-maker-component-query-library';
import {getTemplateName} from '@EmailMakerReact/lib/email-maker-save-payload-library';

/**
 * Fires `onExternalChange` with the current template name whenever the wrapper's template-name prop
 * is written from outside this input — load-time seeding, AI redesign, undo/redo — so a mounted
 * input never drifts from the source of truth save reads.
 */
export function useSyncTemplateNameFromWrapper(editor: Editor | null, onExternalChange: (name: string) => void): void {
  useEffect(() => {
    if (!editor) {
      return undefined;
    }
    const wrapper = getMainWrapper(editor);
    if (!wrapper) {
      return undefined;
    }
    const eventName = `change:${EMAIL_MAKER_PROPS.TEMPLATE_NAME}`;
    const handleWrapperNameChange = (): void => {
      onExternalChange(getTemplateName(editor));
    };
    wrapper.on(eventName, handleWrapperNameChange);
    return (): void => {
      wrapper.off(eventName, handleWrapperNameChange);
    };
  }, [editor, onExternalChange]);
}
